var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("header", { attrs: { "is-transparent": true } }),
    _vm._v(" "),
    _c("section", { staticClass: "hero-section" }, [
      _c("div", { staticClass: "split-container" }, [
        _c(
          "div",
          { staticClass: "split-container__item split-container__item--left" },
          [
            _c("div", { staticClass: "split-container__item__copy" }, [
              _c("picture", { staticClass: "hero-section__ilustration" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "split-container__item__text" }, [
                  _c("h4", [
                    _vm._v(_vm._s(_vm.$t("Sign-up witouth any cost")))
                  ]),
                  _vm._v(" "),
                  _c("h4", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("Manage your Insurance Policies and Receipts")
                        )
                    )
                  ]),
                  _vm._v(" "),
                  _c("h4", [
                    _vm._v(
                      " " + _vm._s(_vm.$t("Speak with your account manager"))
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._m(2)
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "split-container__item split-container__item--right" },
          [
            _c("a", { attrs: { href: "/" } }, [
              _c("div", { staticClass: "content-svg" }, [_c("kw-close")], 1)
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "split-container__item__copy" },
              [
                !_vm.showErrorPage
                  ? _c("div", { staticClass: "form-container" }, [
                      _c("div", { staticClass: "form__title" }, [
                        _c("img", {
                          staticClass:
                            "split-container__item--right__only-mobile",
                          attrs: {
                            src: require("../../../../assets/logo4login.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("h3", [_vm._v(_vm._s(_vm.$t("Hi")))]),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _vm._v(
                              _vm._s(_vm.$t("Already have an account?")) +
                                "\n                        "
                            ),
                            _c(
                              "router-link",
                              { attrs: { to: { name: "Login" } } },
                              [_vm._v(_vm._s(_vm.$t("Log in")))]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "form",
                        {
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _c("kw-first-name", {
                            attrs: { placeholder: _vm.$t("First name") },
                            model: {
                              value: _vm.form.first_name,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "first_name", $$v)
                              },
                              expression: "form.first_name"
                            }
                          }),
                          _vm._v(" "),
                          _c("kw-last-name", {
                            attrs: { placeholder: _vm.$t("Last name") },
                            model: {
                              value: _vm.form.last_name,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "last_name", $$v)
                              },
                              expression: "form.last_name"
                            }
                          }),
                          _vm._v(" "),
                          _c("kw-nif", {
                            attrs: {
                              placeholder: _vm.$t("Nif"),
                              required: true,
                              isNifUnique: true
                            },
                            model: {
                              value: _vm.form.nif,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "nif", $$v)
                              },
                              expression: "form.nif"
                            }
                          }),
                          _vm._v(" "),
                          _c("kw-email", {
                            attrs: {
                              placeholder: _vm.$t("Your Email Address"),
                              isReadOnly: _vm.isCustomer,
                              isUnique: true
                            },
                            model: {
                              value: _vm.form.email,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "email", $$v)
                              },
                              expression: "form.email"
                            }
                          }),
                          _vm._v(" "),
                          _c("kw-phone", {
                            attrs: { placeholder: _vm.$t("Your Phone number") },
                            model: {
                              value: _vm.form.phone_number,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "phone_number", $$v)
                              },
                              expression: "form.phone_number"
                            }
                          }),
                          _vm._v(" "),
                          _c("kw-password", {
                            attrs: {
                              label: _vm.$t("Password"),
                              placeholder: _vm.$t("Your Password")
                            },
                            model: {
                              value: _vm.form.password,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "password", $$v)
                              },
                              expression: "form.password"
                            }
                          }),
                          _vm._v(" "),
                          _c("kw-button", {
                            attrs: {
                              label: _vm.$t("Sign up"),
                              isPrimary: true,
                              type: "submit",
                              isLoading: _vm.isLoading,
                              disabled: _vm.isFormValid
                            },
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                                return _vm.onSubmit($event)
                              }
                            },
                            nativeOn: {
                              click: function($event) {
                                return _vm.registerHandler($event)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.isCustomer
                        ? _c("div", { staticClass: "social" }, [
                            _c(
                              "a",
                              [
                                _c("kw-facebook", {
                                  on: { user: _vm.handleAuth }
                                }),
                                _vm._v(" "),
                                _c("kw-google", {
                                  on: { user: _vm.handleAuth }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showErrorPage && _vm.errorCode === 400
                  ? _c(
                      "kw-error",
                      {
                        attrs: {
                          title: _vm.$t("Ups!"),
                          message:
                            _vm.$t(
                              "We are sorry but we cannot register yourself with the link provided. Please contact support and provide the follow error code"
                            ) +
                            " C-" +
                            _vm.customerReference +
                            "."
                        }
                      },
                      [
                        _c("kw-button", {
                          attrs: { label: _vm.$t("Contact support") }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showErrorPage && _vm.errorCode === 422
                  ? _c(
                      "kw-error",
                      {
                        attrs: {
                          title: _vm.$t("Ups!"),
                          message: _vm.$t(
                            "We find that your email is already registered. Please login."
                          )
                        }
                      },
                      [_c("kw-button", { attrs: { label: _vm.$t("Login") } })],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [_c("br")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "split-container__item__logo" }, [
      _c("img", {
        attrs: { src: require("../../../../assets/logo4login.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "split-container__item__image" }, [
      _c("img", { attrs: { src: require("../../../../assets/teste1.png") } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48c5e34c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48c5e34c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/views/signUp/signUp.html
// module id = null
// module chunks = 